import { render, staticRenderFns } from "./collection-order-add.vue?vue&type=template&id=5c384687&scoped=true&"
import script from "./collection-order-add.vue?vue&type=script&lang=ts&"
export * from "./collection-order-add.vue?vue&type=script&lang=ts&"
import style0 from "./collection-order-add.vue?vue&type=style&index=0&id=5c384687&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c384687",
  null
  
)

export default component.exports